var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9abac5cb4366ad64e4d9fcc7bb335fe1375c453f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sv-hero-web@socialvenu"]={id:"9abac5cb4366ad64e4d9fcc7bb335fe1375c453f"};
      